export default "assets/line-be5eb17a.svg";